module.exports = __webpack_public_path__ + "static/img/2-1.278a32b5.png";